import React from 'react';
import Image from '../../Image';

const MetaQuality = props => (
  <li className="metaqualities__quality clearfix">
    <div className="metaqualities__image">
      <Image icon={props.data.image} alt={props.data.name} type="icon" width={100} height={130} />
    </div>
    <div className="metaqualities__body">
      <p className="metaqualities__title">
        { props.data.name }
        {' '}
        <em>
(Level:
          { props.data.level }
)
        </em>
      </p>
      <p dangerouslySetInnerHTML={{ __html: props.data.description }} />
    </div>
  </li>
);

export default MetaQuality;
